import { useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { FormBentuk } from "./FormBentuk";
import { FormDetail } from "./FormDetail";
import { FormAnggota } from "./FormAnggota";
import { FormPartner } from "./FormPartner";
import { FormValidasi } from "./FormValidasi";
import { FormPelaksana } from "./FormPelaksana";
import { RootState } from "../../../store/rootReducer";
import { useHistory, useLocation } from "react-router-dom";
import { getPartnerAsync } from "../../../reducers/partner/partner.actions";
import { getEmployeeAsync } from "../../../reducers/employee/employee.actions";
import { getDepartmentAsync } from "../../../reducers/department/department.actions";
import { getJenisDokumenAsync } from "../../../reducers/jenisDokumen/jenisDokumen.actions";
import { getStatusKerjasamaAsync } from "../../../reducers/statusKerjasama/statusKerjasama.actions";
import { getBentukKerjasamaAsync } from "../../../reducers/bentukKerjasama/bentukKerjasama.actions";
import { getDetailDokumenKerjasamaAsync, initializeCreateDokumenKerjasama, updateFile } from "../../../reducers/dokumenKerjasama/dokumenKerjasama.actions";

export const DokumenKerjasamaDetailPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const redirectQueue = useSelector((state: RootState) => state.dokumenKerjasama.redirectQueue);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getPartnerAsync.request());
    dispatch(getEmployeeAsync.request());
    dispatch(getDepartmentAsync.request());
    dispatch(getJenisDokumenAsync.request({ status: 1 }));
    dispatch(getStatusKerjasamaAsync.request({ status: 1 }));
    dispatch(getBentukKerjasamaAsync.request({ status: 1 }));
  }, []);

  useEffect(() => {
    if (redirectQueue) {
      history.push(redirectQueue);
      dispatch(initializeCreateDokumenKerjasama());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectQueue]);

  useEffect(() => {
    dispatch(updateFile(null));
    const paths = location.pathname.split("/");
    if (paths[2] === 'create') {
      dispatch(initializeCreateDokumenKerjasama());
    } else {
      const idDokumen = parseInt(paths[2]);
      if (idDokumen && !isNaN(idDokumen)) {
        dispatch(getDetailDokumenKerjasamaAsync.request({ DOK_ID: idDokumen }));
      } else {
        history.push(`/dokumen-kerjasama/create`);
      }
    }
  }, [location.pathname]);

  return (
    <DokumenKerjasamaDetailPageWrapper>
      <section className="content-header">
        <h1>
          Buat Dokumen Kerjasama Baru<small>Pelaksana Kerjasama</small>
        </h1>
      </section>
      <section className="content">
        <section className="content">
          <div className="row">
            <div className="col-lg-4">
              <FormDetail />
            </div>
            <div className="col-lg-4">
              <FormPelaksana />
              <FormPartner />
              <FormBentuk />
              <FormAnggota />
            </div>
            <div className="col-lg-4">
              <FormValidasi />
            </div>
          </div>
        </section>
      </section>
    </DokumenKerjasamaDetailPageWrapper>
  );
};

const DokumenKerjasamaDetailPageWrapper = styled.div`
  .react-datepicker-wrapper {
    display: block;
  }
`;